import { ContractOffer } from "@type/contract";
import { convertCurrency } from "@util/currency";
import { parseFormat } from "@util/date";
import { getStatusBadgeClass } from "@util/string";

interface Props {
  contract: ContractOffer;
  onClick: (contract: ContractOffer) => void;
}

export function ContractItem({ contract, onClick }: Props) {
  return (
    <div
      className="border bg-white border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
      onClick={() => onClick(contract)}
    >
      <div className="flex flex-col sm:flex-row space-y-2 sm:space-x-2 justify-between items-start">
        <div>
          <h3 className="font-bold text-gray-900">{contract.job_title}</h3>
          <p className="text-sm text-gray-700">{contract.company_name}</p>
          <div className="flex gap-4 text-xs text-gray-600 mt-2">
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-gray-500 hidden sm:block"></span>
              Offer Date: {parseFormat(contract.created_at, "D MMMM YYYY")}
            </span>
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-gray-500 hidden sm:block"></span>
              Salary: {convertCurrency(contract.salary, contract.salary_currency)}
            </span>
          </div>
        </div>
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusBadgeClass(contract.status)}`}
        >
          {contract.status}
        </span>
      </div>
    </div>
  );
}
